import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';

import '@valwin/facto/styles/fonts.css';
import '@valwin/facto/styles/global.css';

import { clearAllTenantsRevisions } from '~shared/api';
import '~shared/i18n/setup';

import { App } from './app/App';

import './app/styles/global.css';

const tagManagerArgs = {
  gtmId: 'GTM-WT28QNZ',
  dataLayer: {
    network: 'product',
    site: 'backoffice-group',
    language: 'fr',
  },
};

TagManager.initialize(tagManagerArgs);

clearAllTenantsRevisions();

ReactDOM.createRoot(document.querySelector('#root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
